class SubmitScTracking{
  constructor(trackingLinks) {
      try {
          this.trackingLinks = trackingLinks;
        
          this.trackingLinks.forEach((link, i) => {
              link.addEventListener("click", () => this.submitTrackingEvent(link));
          });
      }catch (error) {
          console.log('nope',error);
      }
    }

  submitTrackingEvent = async (link) => {
    let goalId = link.getAttribute('data-sd-sc-goals');
    let url = link.getAttribute("data-action");

    if(goalId != "") {
      fetch(url + '?eventId=' + encodeURIComponent(goalId), { method: 'POST' })
      .then(
        result => result.json()
      )
      .catch(
        error => {console.log(error);}
      )
    }
  }
}

export default SubmitScTracking;